/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectValidationRequirementType } from './';
import {
    ProjectValidationRequirementTypeFromJSON,
    ProjectValidationRequirementTypeFromJSONTyped,
    ProjectValidationRequirementTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInformationResourceValidationInfo
 */
export interface ProjectInformationResourceValidationInfo {
    /**
     * 
     * @type {Array<ProjectValidationRequirementType>}
     * @memberof ProjectInformationResourceValidationInfo
     */
    projectValidationRequirement?: Array<ProjectValidationRequirementType>;
}

/**
 * Check if a given object implements the ProjectInformationResourceValidationInfo interface.
 */
export function instanceOfProjectInformationResourceValidationInfo(value: object): value is ProjectInformationResourceValidationInfo {
    return true;
}

export function ProjectInformationResourceValidationInfoFromJSON(json: any): ProjectInformationResourceValidationInfo {
    return ProjectInformationResourceValidationInfoFromJSONTyped(json, false);
}

export function ProjectInformationResourceValidationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceValidationInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'projectValidationRequirement': json['projectValidationRequirement'] == null ? undefined : ((json['projectValidationRequirement'] as Array<any>).map(ProjectValidationRequirementTypeFromJSON)),
    };
}

export function ProjectInformationResourceValidationInfoToJSON(value?: ProjectInformationResourceValidationInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectValidationRequirement': value['projectValidationRequirement'] == null ? undefined : ((value['projectValidationRequirement'] as Array<any>).map((v) => ProjectValidationRequirementTypeToJSON(v))),
    };
}

